class CustomSelect {
            constructor(selectElement) {
                this.selectElement = selectElement;
                this.customSelect = selectElement.nextElementSibling;
                this.selected = this.customSelect.querySelector('.select-selected');
                this.items = this.customSelect.querySelector('.select-items');
                this.options = this.items.querySelectorAll('div[data-value]');
                
                this.init();
            }

            init() {
                this.selected.addEventListener('click', (e) => {
                    e.stopPropagation();
                    
                    const isCurrentlyOpen = !this.items.classList.contains('select-hide');
                    
                    this.closeAllSelect();
                    
                    if (!isCurrentlyOpen) {
                        this.items.classList.remove('select-hide');
                        this.selected.classList.add('select-arrow-active');
                    }
                });

                this.options.forEach(option => {
                    option.addEventListener('click', (e) => {
                        e.stopPropagation();
                        const value = option.dataset.value;
                        const content = option.innerHTML;
                        
                        this.selected.querySelector('.option-content').innerHTML = content;
                        
                        this.selectElement.value = value;
                        
                        this.options.forEach(opt => opt.classList.remove('same-as-selected'));
                        option.classList.add('same-as-selected');
                        
                        this.items.classList.add('select-hide');
                        this.selected.classList.remove('select-arrow-active');
                        
                        this.selectElement.dispatchEvent(new Event('change'));
                        
                        document.getElementById('selected-value').textContent = value;
                    });
                });

                document.addEventListener('click', (e) => {
                    if (!e.target.closest('.custom-select')) {
                        this.closeAllSelect();
                    }
                });
            }

            closeAllSelect() {
                const allCustomSelects = document.querySelectorAll('.custom-select');
                allCustomSelects.forEach(select => {
                    select.querySelector('.select-items').classList.add('select-hide');
                    select.querySelector('.select-selected').classList.remove('select-arrow-active');
                });
            }
        }

        document.addEventListener('DOMContentLoaded', function() {
            const selectElement = document.getElementById('thb-currency-code-1');
            new CustomSelect(selectElement);
        });